import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';

// ============================================
// MODERN REGISTER COMPONENT
// ============================================

export default function Register({ onSwitchToLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const [token, setToken] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setLoading(true);
    const result = await register(email, password, firstName, lastName, token);
    if (result.success) {
      setMessage('success');
      setTimeout(onSwitchToLogin, 2000);
    } else {
      setMessage(result.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlToken = urlParams.get('token');
    if (urlToken) {
      setToken(urlToken);
    }
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#0f172a',
      padding: '1rem'
    }}>
      <div style={{
        maxWidth: '420px',
        width: '100%',
        background: '#1e293b',
        borderRadius: '24px',
        padding: '2.5rem',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        animation: 'slideUp 0.5s ease-out'
      }}>
        <div style={{
          width: '64px',
          height: '64px',
          background: '#FFEB3B',
          borderRadius: '16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 1.5rem',
          fontSize: '32px'
        }}>✨</div>
        <h2 style={{
          fontSize: '28px',
          fontWeight: '700',
          textAlign: 'center',
          marginBottom: '0.5rem',
          color: '#ffffff'
        }}>Luo tunnus</h2>
        <p style={{
          textAlign: 'center',
          color: '#94a3b8',
          marginBottom: '2rem',
          fontSize: '14px'
        }}>Luo tunnus päästäksesi hallinnoimaan tehtäviäsi</p>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '14px', fontWeight: '500', color: '#ffffff' }}>
              Etunimi
            </label>
            <input
              type="text"
              placeholder="Matti"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              style={{
                width: '100%',
                padding: '0.875rem 1rem',
                background: '#0f172a',
                border: '2px solid #334155',
                borderRadius: '12px',
                fontSize: '15px',
                outline: 'none',
                color: '#ffffff'
              }}
              required
            />
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '14px', fontWeight: '500', color: '#ffffff' }}>
              Sukunimi
            </label>
            <input
              type="text"
              placeholder="Meikäläinen"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              style={{
                width: '100%',
                padding: '0.875rem 1rem',
                background: '#0f172a',
                border: '2px solid #334155',
                borderRadius: '12px',
                fontSize: '15px',
                outline: 'none',
                color: '#ffffff'
              }}
              required
            />
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '14px', fontWeight: '500', color: '#ffffff' }}>
              Email
            </label>
            <input
              type="email"
              placeholder="matti@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                width: '100%',
                padding: '0.875rem 1rem',
                background: '#0f172a',
                border: '2px solid #334155',
                borderRadius: '12px',
                fontSize: '15px',
                outline: 'none',
                color: '#ffffff'
              }}
              required
            />
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '14px', fontWeight: '500', color: '#ffffff' }}>
              Salasana
            </label>
            <input
              type="password"
              placeholder="Vähintään 8 kirjainta"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: '100%',
                padding: '0.875rem 1rem',
                background: '#0f172a',
                border: '2px solid #334155',
                borderRadius: '12px',
                fontSize: '15px',
                outline: 'none',
                color: '#ffffff'
              }}
              required
            />
          </div>
          {message && (
            <div style={{
              padding: '0.875rem',
              background: message === 'success' ? '#10b981' : '#ef4444',
              border: message === 'success' ? '1px solid #10b981' : '1px solid #ef4444',
              borderRadius: '12px',
              color: '#ffffff',
              fontSize: '14px'
            }}>
              {message === 'success' ? 'Tunnusten luominen onnistui! Ohjataan kirjautumaan...' : message}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '0.875rem',
              background: loading ? '#64748b' : '#FFEB3B',
              color: loading ? '#ffffff' : '#0f172a',
              border: 'none',
              borderRadius: '12px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'transform 0.2s',
              marginTop: '0.5rem'
            }}
            onMouseOver={(e) => !loading && (e.target.style.transform = 'translateY(-2px)')}
            onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
          >
            {loading ? 'Luodaan tunnuksia...' : 'Create Account'}
          </button>
        </form>

        <p style={{
          marginTop: '1.5rem',
          textAlign: 'center',
          color: '#94a3b8',
          fontSize: '14px'
        }}>
          Joko sinulla on tunnukset?{' '}
          <span
            onClick={onSwitchToLogin}
            style={{
              color: '#FFEB3B',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            Kirjaudu
          </span>
        </p>
      </div>
    </div>
  );
}
